import { createSlice } from "@reduxjs/toolkit";

interface EllipsisDropdownState {
  isOpen: boolean;
}

const initialState: EllipsisDropdownState = {
  isOpen: false,
};

const ellipsisDrodownSlice = createSlice({
  name: "ellipsisDropdownSlice",
  initialState,
  reducers: {
    toggleDropdown(state) {
      state.isOpen = !state.isOpen;
    },
    closeDropdown(state) {
      state.isOpen = false;
    },
    openDropdown(state) {
      state.isOpen = true;
    },
  },
});

export const { closeDropdown, openDropdown, toggleDropdown } =
  ellipsisDrodownSlice.actions;

export default ellipsisDrodownSlice.reducer;
